import type { AppTourConfig } from '@fordeer/app-tour'
import { AppTourPolarisTooltip } from '@features/virtual-tour/components/AppTourPolarisTooltip'

export const invoiceVirtualTourConfig: AppTourConfig = {
  allowClose: true,
  allowKeyboardControl: true,
  tooltipComponent: AppTourPolarisTooltip,
}
